import React from 'react';
import { Tag } from '@juno/client-api/model';
import { FiltersApplied, MentorshipFilter } from '@juno/ui';
import { useDirectoryFilters } from '../Contexts/DirectoryFiltersContext';

interface DirectoryFiltersAppliedProps {
  tagsFiltersApplied: Tag[];
  mentorshipFiltersApplied: MentorshipFilter[];
  loadingData: boolean;
}

const DirectoryFiltersApplied: React.FC<DirectoryFiltersAppliedProps> = ({
  tagsFiltersApplied,
  mentorshipFiltersApplied,
  loadingData,
}) => {
  const { removeTagFilter, removeMentorshipFilter } = useDirectoryFilters();

  if (tagsFiltersApplied.length === 0 && mentorshipFiltersApplied.length === 0) {
    return null;
  }

  return (
    <FiltersApplied
      tagFilters={tagsFiltersApplied}
      mentorshipFilters={mentorshipFiltersApplied}
      disableAll={loadingData}
      removeTagFilter={removeTagFilter}
      removeMentorshipFilter={removeMentorshipFilter}
    />
  );
};

export default DirectoryFiltersApplied;
